import React from 'react'
import {PALETTE} from '../ThemeConstants'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { NavLink } from 'react-router-dom'

export default function ListElement({IconHeader, description, url="#footer", alignmentClass="text-start"}) {
    return (
      <div className={`justify-content-center ${alignmentClass}`} style={{color:PALETTE.LIGHTGRAY}}>
        <NavLink to={url} className="text-decoration-none" style={{color:PALETTE.LIGHTGRAY}}>
          <Row>
          {IconHeader &&
            <>
              <Col xs={2} className="justify-content-center"> {IconHeader} </Col>
              <Col xs={10}> <p style={{fontSize:"16px"}}> {description} </p> </Col>
            </>
          }
          {!IconHeader &&
            <>
              <Col> <p style={{fontSize:"16px"}}> {description} </p> </Col>
            </>
          }
          </Row>
        </NavLink>
      </div>
    )
  }